import { render, staticRenderFns } from "./customWidget.vue?vue&type=template&id=96eaf696&"
import script from "./customWidget.vue?vue&type=script&lang=js&"
export * from "./customWidget.vue?vue&type=script&lang=js&"
import style0 from "./customWidget.vue?vue&type=style&index=0&id=96eaf696&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports